import React, { useEffect, useMemo } from 'react'
import { useFocusable } from '@noriginmedia/norigin-spatial-navigation'
import classNames from 'classnames'

import tts from '../../lib/TTS'

import type { FocusableCardProps } from './types'

function FocusableCard<T>({
  onEnterPress,
  onFocus,
  layout,
  index,
  ttsText = '',
  className = '',
  children,
  onLeftExit,
}: FocusableCardProps<T>) {
  const { ref, focused } = useFocusable({
    onEnterPress,
    onFocus,
    onArrowPress: (direction) => {
      if (direction === 'left' && onLeftExit) {
        onLeftExit()
        return false
      }
      return true
    },
    extraProps: { index },
  })

  useEffect(() => {
    if (focused && ttsText) {
      tts.stopRead()
      tts.addTextToRead(ttsText)
    }
  }, [focused])

  const style = useMemo(
    () =>
      ({
        height: `${layout.cardHeight}px`,
        width: `${layout.cardWidth}px`,
        minWidth: `${layout.cardWidth}px`,
        marginRight: `${layout.cardMarginRight}px`,
      } as React.CSSProperties),
    [layout]
  )

  return (
    <div
      ref={ref}
      style={style}
      className={classNames('focusable-card', {
        [className]: !!className,
        'focusable-card--focused': focused,
      })}
    >
      {children}
    </div>
  )
}

export default FocusableCard
